import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import CustomOrdersPage from '../pages/custom-orders/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/custom-orders',
    element: <CustomOrdersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
